import type { BattleContender } from './types';

export type PlayableGame = {
  gameId: number;
  displayName: string;
  thumbnailUrl?: string;
  viaFallbackGame: boolean;
};

/** The game a slot launches right now: its fallback while `viaFallbackGame`, otherwise itself. */
export function resolvePlayableGame(contender: BattleContender): PlayableGame {
  if (!contender.viaFallbackGame || contender.playGameId === undefined) {
    return {
      gameId: contender.playGameId ?? contender.gameId,
      displayName: contender.playDisplayName || contender.displayName,
      thumbnailUrl: contender.playThumbnailUrl ?? contender.thumbnailUrl,
      viaFallbackGame: false,
    };
  }

  return {
    gameId: contender.playGameId,
    displayName: contender.playDisplayName || contender.displayName,
    thumbnailUrl: contender.playThumbnailUrl,
    viaFallbackGame: true,
  };
}
